import { Cell, Row } from "react-table";
import { CustomFieldModel, CustomFieldOption } from "src/api/contractGroup/contractgroup-type";
import { BaseButton, BaseToggle, BaseTooltip } from "src/components";
import { FIELD_TYPE_OPTIONS } from "../../contractgroup-constant";

export const customFieldColumns = [
  {
    Header: "순서",
    accessor: "",
    width: 100,
    Cell: ({
      row,
      rows,
      onUpdateCustomField,
    }: {
      row: Row<CustomFieldModel>;
      rows: Row<CustomFieldModel>[];
      onUpdateCustomField: (request: CustomFieldModel | CustomFieldModel[]) => Promise<void>;
    }) => {
      const handleOrderChange = (direction: -1 | 1) => {
        const currentItem = row.original; // 클릭한 현재 필드
        const targetItem = rows[row.index + direction].original; //현재 필드 기준으로 이동할 target 필드

        const updatedCurrentItem = {
          fieldId: currentItem.fieldId,
          // fieldName: currentItem.fieldName,
          // fieldType: currentItem.fieldType,
          orderNum: targetItem.orderNum, // 현재 필드의 순서 번호 대상 필드의 순서 번호 전달
        };

        const updatedTargetItem = {
          fieldId: targetItem.fieldId,
          // fieldName: targetItem.fieldName,
          // fieldType: targetItem.fieldType,
          orderNum: currentItem.orderNum, // 대상 필드의 순서 번호 현재 필드의 순서 번호 전달
        };

        onUpdateCustomField([updatedCurrentItem, updatedTargetItem]);
      };

      return (
        <div className="flex-center " style={{ height: 30 }}>
          <BaseButton //
            title=""
            className={`base-btn ic-chevron-up mr2 cursor-pointer color-white pa0 h30 size-small`}
            disabled={row.index === 0}
            onClick={() => handleOrderChange(-1)}
          />
          <BaseButton //
            title=""
            className={`base-btn ic-chevron-down  cursor-pointer color-white pa0 h30`}
            disabled={row.index === rows.length - 1}
            onClick={() => handleOrderChange(1)}
          />
        </div>
      );
    },
  },
  {
    Header: "id",
    accessor: "fieldId",
    width: 60,
  },
  {
    Header: "필드명",
    accessor: "fieldName",
    width: 200,
  },

  {
    Header: "필드유형",
    accessor: "fieldType",
    width: 140,
    Cell: ({ row }: Cell<CustomFieldModel>) => {
      const fieldType = row.original.fieldType;
      return <BaseTooltip contents={FIELD_TYPE_OPTIONS.find((option) => option.value === fieldType)?.label} isSingleLine={true} />;
    },
  },
  {
    Header: "필드값(옵션)",
    accessor: "optionList",
    width: 320,
    Cell: ({ row }: Cell<CustomFieldModel>) => {
      const options = row.original.optionList?.map((option: CustomFieldOption) => option.optionName).join(", ");
      return <BaseTooltip contents={options || "-"} isSingleLine={true} />;
    },
  },

  {
    Header: ({ rows }: { rows: Row<CustomFieldModel>[] }) => {
      const visibleCount = rows.filter((row) => row.original.isVisible).length;

      return `노출 (${visibleCount}/5)`;
    },
    accessor: "isVisible",
    width: 120,
    Cell: ({
      row,
      onUpdateCustomField,
    }: {
      row: Row<CustomFieldModel>;
      onUpdateCustomField: (request: CustomFieldModel, editType?: "orderNum" | "visible") => Promise<void>;
    }) => (
      <BaseToggle
        onChange={(checked: boolean) => {
          const request = { ...row.original, isVisible: checked };
          onUpdateCustomField(request, "visible");
        }}
        checked={row.original.isVisible}
      />
    ),
  },
  {
    Header: "설정",
    accessor: "",
    width: 80,
    Cell: ({ row, handleSetCustomFieldDetail }: { row: Row<CustomFieldModel>; handleSetCustomFieldDetail: (detail: CustomFieldModel) => void }) => (
      <BaseButton
        className="color-white"
        title="설정"
        onClick={() => {
          handleSetCustomFieldDetail(row.original);
        }}
      />
    ),
  },
  {
    Header: "삭제",
    accessor: "",
    width: 48,
    Cell: ({ row, onDeleteCustomField }: { row: Row<CustomFieldModel>; onDeleteCustomField: (request: CustomFieldModel) => Promise<void> }) => {
      return (
        <button
          className="base-trash-btn color-bg-gray h40"
          onClick={() => {
            const request = { ...row.original, isDeleted: true };
            onDeleteCustomField(request);
          }}
        />
      );
    },
  },
];
